import { Component } from "react"
import PropTypes from "prop-types"
import { get, map } from "lodash"
import { IconButton, Menu, Chip, ListSubheader } from "@mui/material"
import { Layers } from "@mui/icons-material"
import Tooltip from "components/material/tooltip"
import GroupingOption from "./grouping-option"
import "./style.scss"

class GroupingMenu extends Component {
  static propTypes = {
    setGrouping: PropTypes.func.isRequired,
    availableRollups: PropTypes.array.isRequired,
    currentGrouping: PropTypes.object,
    disabled: PropTypes.bool,
  }

  constructor(...args) {
    super(...args)

    this.state = {
      menuAnchor: null,
      groupingRef: null,
    }
  }

  handleOpenMenu = () => {
    this.setState({ menuAnchor: this.state.groupingRef })
  }

  handleCloseMenu = () => {
    this.setState({ menuAnchor: null })
  }

  handleSetGrouping = (grouping) => {
    const { setGrouping } = this.props
    setGrouping(grouping)
    this.handleCloseMenu()
  }

  setResetGrouping = () => {
    const { setGrouping } = this.props
    setGrouping(null)
  }

  groupingRef = (node) => {
    this.setState({ groupingRef: node })
  }

  render() {
    const { menuAnchor } = this.state
    const { availableRollups, currentGrouping, disabled } = this.props
    return <div className="components_grouping-menu">
      {currentGrouping
        ? <Chip label={get(currentGrouping, "label")} onDelete={this.setResetGrouping} />
        : (
          <>
            <Tooltip enterDelay={300} title="Group By...">
              <IconButton
                ref={this.groupingRef}
                onClick={this.handleOpenMenu}
                className="contributor-groups"
                disabled={disabled}
                size="large"
              >
                <Layers />
              </IconButton>
            </Tooltip>
            <Menu className="rollup-menu" anchorEl={menuAnchor} open={!!menuAnchor} onClose={this.handleCloseMenu}>
              {map(availableRollups, (rollup, i) =>
                  rollup.options ? (
                    <div key={`${rollup.id}${i}`}>
                      {rollup.label && <ListSubheader classes={{ root: "rollup-category-header" }}>{rollup.label}</ListSubheader>}
                      {map(rollup.options, (optionRollup, y) => <GroupingOption
                        key={`${optionRollup.id}${y}`}
                        currentGrouping={currentGrouping}
                        setGrouping={this.handleSetGrouping}
                        grouping={optionRollup}
                      />)}
                    </div>
                  ) : <GroupingOption
                    key={i}
                    currentGrouping={currentGrouping}
                    setGrouping={this.handleSetGrouping}
                    grouping={rollup}
                  />,
                )}
            </Menu>
          </>
          )}
    </div>
  }
}

export default GroupingMenu
